import React from 'react';
import { MdCallEnd } from 'react-icons/md';
const HangUp = (props) => React.createElement(MdCallEnd, Object.assign({}, props));
export default HangUp;
